export default function initMaps() {
  const script = document.createElement("script");
  const src =
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyCU_8hYqLkm_CBpIAU0gbEkcDX5tqr10xo&callback=initMap";

  script.setAttribute("src", src);
  script.setAttribute("async", "");

  document.head.appendChild(script);

  const elements = document.querySelectorAll(".map");

  if (elements.length === 0) {
    return;
  }

  window.initMap = () => {
    elements.forEach((element) => renderMap(element));
  };
}

function renderMap(element) {
  const latitude = element.dataset.latitude;
  const longitude = element.dataset.longitude;

  if (!latitude || !longitude) {
    return;
  }

  const googleMap = new google.maps.Map(element.querySelector(".map__inner"), {
    center: {
      lat: Number(latitude),
      lng: Number(longitude),
    },
    zoom: 10,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
  });

  new google.maps.Marker({
    position: new google.maps.LatLng(Number(latitude), Number(longitude)),
    map: googleMap,
    title: "Hello World!",
  });

  googleMap.panBy(-300, 10);
}
